import { StyledSummaryTableCell, SummaryHeader } from '../../../../components';
import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IUpdateMaterialResponse } from '../../../../types';
import type { FC } from 'react';

interface IMaterialsProps {
    setStep: (step: number) => void;
}

export const MaterialSummary: FC<IMaterialsProps> = ({ setStep }) => {
    const formContext = useFormContext();
    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    const materials: Array<IUpdateMaterialResponse> = formContext.getValues('allMaterials');

    const onStepClick = () => setStep(4);

    return (
        <div>
            <SummaryHeader isLink onLink={onStepClick}>
                {localization.translate('materialSummary.stepLink')}
            </SummaryHeader>

            {/* NO MATERIAL MESSAGE */}
            {materials?.length === 0 && (
                <span className={'font-medium dark:text-gray-200'}>
                    {localization.translate('materialSummary.noMaterialsMessage')}
                </span>
            )}

            {/* MATERIAL TABLE */}
            {materials?.length !== 0 && (
                <table className={'mt-1'}>
                    <thead>
                        <tr>
                            <StyledSummaryTableCell isHeader>
                                {localization.translate('materialSummary.nameHeader')}
                            </StyledSummaryTableCell>
                            <StyledSummaryTableCell isHeader isNumeric>
                                {localization.translate('materialSummary.quantityHeader')}
                            </StyledSummaryTableCell>
                        </tr>
                    </thead>
                    <tbody>
                        {materials.map((m) => {
                            return (
                                <tr key={m.itemId}>
                                    <StyledSummaryTableCell>{m.name}</StyledSummaryTableCell>
                                    <StyledSummaryTableCell isNumeric>{m.qty}</StyledSummaryTableCell>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};